<script>
  import { TextField, Button } from 'smelte'
  import { API } from '../api/api'
  import {createEventDispatcher} from 'svelte'

  const dispatch = createEventDispatcher()

  const api = new API()
  let loading = false
  let selectedFile = {}
  let ref

  let error = ''
  let hint = ''


  function fileChangeHandler (e) {
    error = ''
    hint = ''
    try {
      if (e.target.files[0] != null) {
        selectedFile = e.target.files[0]
        e.target.value = ''
      }
    } catch (e) {
      console.log('[ERROR] ', e)
    }
  }

  async function fileSaveHandler () {
    console.log('Uploading to ' + api.getURL('') + ' ' + selectedFile.name)

    loading = true
    const formData = new FormData()
    formData.append('file', selectedFile, selectedFile.name)

    await api.UploadImage(formData)
      .then(res => {
        console.log('File uploaded:' + res.status + ',' + res.statusText)
        hint = 'Success'
        selectedFile = {}
        dispatch('success')
      })
      .catch(err => {
        console.log(err)
        error = 'File processing failed'
        dispatch('error', error)
      })
      .finally(() => {
        loading = false
      })

  }
</script>

<div class="flex items-center">
  <div class="mr-5 md:w-1/3">
    <TextField value={selectedFile.name}
               label={hint && hint !== '' ? 'File uploaded!' : 'Select a file to upload ...'}
               {error}
               readonly
               on:click={() => { ref.click() }} />

    <input bind:this={ref} type="file" class="hidden" accept="*.jpg" on:change={fileChangeHandler}>
  </div>

  <Button disabled={loading || Object.keys(selectedFile).length === 0 && selectedFile.constructor === Object}
          on:click={fileSaveHandler}>
    Upload
  </Button>
</div>